import type { Provider, Type } from '@angular/core';

import {
  ADDRESS_AUTOCOMPLETE_PROVIDER,
  type AddressAutocompleteProvider,
} from '@arya/shared/address-autocomplete-contract';

export const provideAddressAutocomplete = (providerClass: Type<AddressAutocompleteProvider>): Provider => ({
  provide: ADDRESS_AUTOCOMPLETE_PROVIDER,
  useClass: providerClass,
});
